module.exports = __webpack_public_path__ + "static/img/VDadvantage1.119b348.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/VDadvantage1.png
// module id = V+Cg
// module chunks = 0